<template>
  <div
    class="vs-content-sidebar sidebarx main-menu-sidebar items-no-padding"
    :class="{ 'main-menu-sidebar-overlay': $store.state.isSidebarActive }"
    style="
      touch-action: none;
      user-select: none;
      -webkit-user-drag: none;
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    ">
    <OtpPrompt
      :active.sync="showOtpPrompt"
      :login="$store.state.activeUser.email"
      otpRequired
      successEventString="resetRightsVerified"
      @resetRightsVerified="goToResetPage"></OtpPrompt>
    <div
      :class="{ 'sidebar-background': $store.state.isSidebarActive }"
      @click="$store.commit('TOGGLE_IS_SIDEBAR_ACTIVE', false)"></div>

    <div
      class="vs-sidebar vs-sidebar-primary vs-sidebar-parent vs-sidebar-reduceNotRebound">
      <div class="vs-sidebar--items">
        <!-- Logo -->
        <div class="header-sidebar flex items-top justify-between">
          <div class="logo flex items-center">
            <a href="/" class="router-link-active">
              <img
                src="https://static.triple-a.io/assets/images/TripleA-main-logo-transparent.png"
                alt="logo"
                class="logoSideBar" />
            </a>
          </div>

          <template>
            <feather-icon
              icon="XIcon"
              class="m-0 cursor-pointer close-button"
              @click="$store.commit('TOGGLE_IS_SIDEBAR_ACTIVE', false)"></feather-icon>
          </template>
        </div>

        <div
          class="shadow-bottom"
          v-show="showShadowBottom"
          style="display: none"></div>

        <VuePerfectScrollbar
          ref="mainSidebarPs"
          class="scroll-area--main-sidebar pt-2"
          @ps-scroll-y="psSectionScroll">
          <h2>Overview</h2>
          <ul>
            <li class="vs-sidebar--item">
              <router-link
                to="/home"
                exact
                @click.native="setActiveAccount('/home')">
                <span class="feather-icon select-none relative">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    width="24">
                    <path d="M0 0h24v24H0V0z" fill="none" />
                    <path
                      fill="currentColor"
                      d="m12 5.69 5 4.5V18h-2v-6H9v6H7v-7.81l5-4.5M12 3 2 12h3v8h6v-6h2v6h6v-8h3L12 3z" />
                  </svg>
                </span>
                <span class="truncate">Home</span>
                <!---->
              </router-link>
            </li>

            <!-- SIDEBAR ITEM : TRANSACTIONS -->
            <li class="vs-sidebar--item">
              <router-link
                to="/payments"
                exact
                @click.native="setActiveAccount('/payments')">
                <span class="feather-icon select-none relative">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="feather feather-credit-card">
                    <rect x="1" y="4" width="22" height="16" rx="2" ry="2" />
                    <line x1="1" y1="10" x2="23" y2="10" />
                  </svg>
                  <!-- <feather-icon icon="CreditCardIcon" class="w-4 h-4"></feather-icon> -->
                </span>
                <span class="truncate">Payments Admin</span>
                <!---->
              </router-link>
            </li>

            <!-- SIDEBAR ITEM : REFUNDS -->
            <li class="vs-sidebar--item">
              <router-link
                to="/refunds"
                exact
                @click.native="setActiveAccount('/refunds')">
                <span class="feather-icon select-none relative">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="feather feather-corner-up-left">
                    <polyline points="9 14 4 9 9 4"></polyline>
                    <path d="M20 20v-7a4 4 0 0 0-4-4H4"></path>
                  </svg>
                </span>
                <span class="truncate">Refunds Admin</span>
              </router-link>
            </li>

            <!-- SIDEBAR ITEM : CRYPTO PAYOUTS -->
            <li
              class="vs-sidebar--item"
              v-if="activeMerchantGetter && activeMerchantGetter.can_withdraw">
              <router-link
                to="/crypto-payout-admin"
                exact
                @click.native="setActiveAccount('/crypto-payout-admin')">
                <span class="feather-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="currentColor">
                    <path
                      fill-rule="evenodd"
                      d="M5.546.163C5.272.422.05 7.703.015 7.878c-.064.314.029.407 1.292 1.3.658.465 1.247.872 1.308.904.306.16.53.023.977-.595.2-.279.385-.5.41-.492.025.009.31.205.635.437.403.288.634.491.732.644.078.122.327.68.553 1.238.434 1.074.633 1.422 1.01 1.77.363.335 5.617 4.028 5.963 4.191.521.246 1.315.27 1.808.053l.221-.096-.021.533c-.034.836.208 1.534.731 2.112.255.281.878.718 1.104.774.128.032.13.038.13.536 0 .467.009.512.124.627a.384.384 0 0 0 .562 0c.111-.11.124-.166.124-.528v-.404h.355v.355c0 .359.051.524.198.635.133.102.353.075.488-.058.115-.114.125-.161.126-.616l.001-.491.342-.163c.403-.193.847-.56.892-.74.035-.137-.037-.314-.168-.413-.158-.12-.346-.07-.681.181-.718.538-1.517.637-2.295.285-.316-.144-.773-.553-.949-.851-.446-.754-.36-1.796.203-2.476.508-.615 1.437-.907 2.223-.7.341.09.56.205.857.45.179.147.296.205.413.205.308 0 .477-.258.356-.543-.08-.188-.576-.566-.958-.728l-.237-.1v-.495c0-.428-.014-.509-.104-.604-.163-.174-.425-.164-.593.021-.098.108-.114.181-.114.524v.4h-.355v-.4c0-.346-.015-.417-.118-.535-.163-.188-.41-.188-.574 0-.106.122-.118.186-.118.607v.472l-.331.161c-.183.089-.347.185-.365.214-.018.03-.06-.108-.094-.305-.087-.511-.272-.876-.605-1.193l-.284-.27.117-.076c.242-.157.921-.442 1.298-.544.578-.158 1.939-.157 2.518.002 1.389.378 2.588 1.35 3.21 2.599.381.764.524 1.383.522 2.254-.008 2.53-1.913 4.611-4.486 4.898-2.046.229-4.086-.89-4.998-2.74a6.2 6.2 0 0 1-.35-.874c-.108-.391-.23-1.38-.18-1.46.016-.025-.069-.095-.188-.154-.12-.06-.361-.21-.538-.334-.176-.123-.335-.209-.354-.19-.073.072-.027 1.65.06 2.026.29 1.278.877 2.314 1.812 3.199.502.475.88.739 1.496 1.044a6.138 6.138 0 0 0 6.941-1.035c1.07-1.012 1.702-2.255 1.896-3.727.069-.52.032-1.38-.08-1.907a6.165 6.165 0 0 0-2.293-3.616c-.81-.607-2-1.1-2.913-1.207a1.915 1.915 0 0 1-.291-.045c0-.086-1.315-3.39-1.429-3.591-.416-.734-1.108-1.405-1.81-1.755-.155-.077-1.468-.633-2.917-1.234L9.597 4.151l-.669-.47c-.368-.258-.682-.492-.7-.52-.016-.027.084-.212.223-.413.51-.734.507-.739-1.087-1.862C6.262.109 6.084 0 5.914 0c-.15 0-.234.037-.368.163Zm1.205 1.668c.367.261.62.474.6.505-.048.077-4.467 6.2-4.571 6.335l-.087.112-.6-.43a27.548 27.548 0 0 0-.672-.469c-.053-.03.517-.853 2.274-3.286 1.29-1.785 2.362-3.24 2.383-3.232.02.008.324.217.673.465Zm1.568 2.8.697.496 2.773 1.153c1.526.635 2.895 1.226 3.044 1.315.322.191.889.766 1.09 1.105.104.178 1.249 3.039 1.249 3.124 0 .007-.143.037-.317.067-.174.03-.476.1-.671.153-.195.054-.368.082-.384.063a6.397 6.397 0 0 1-.222-.511c-.341-.844-.52-1.056-1.42-1.69-.8-.563-.877-.593-1.47-.594-.472 0-.533.012-.843.163-.398.194-.709.51-.896.907-.11.237-.134.358-.135.713 0 .38.017.463.161.753.09.179.26.417.38.53.12.112.933.708 1.806 1.323.969.684 1.627 1.181 1.687 1.277.15.237.113.7-.076.947-.314.407-.936.551-1.407.326-.13-.062-1.462-.982-2.96-2.045-2.05-1.454-2.765-1.988-2.888-2.155-.09-.123-.318-.608-.506-1.08-.632-1.58-.785-1.794-1.784-2.502-.313-.223-.57-.418-.569-.434 0-.015.64-.916 1.421-2 .942-1.307 1.442-1.96 1.482-1.935.033.02.374.26.758.532Zm-6.112 2.63c-.195.192-.186.476.02.68.137.135.18.15.363.126.263-.035.396-.166.431-.427.024-.181.01-.224-.127-.359-.206-.205-.492-.213-.687-.02Zm11.073 3.415c.94.635.946.643 1.28 1.427l.221.52-.286.19c-.158.103-.306.188-.33.188-.094 0-2.057-1.438-2.131-1.562a.85.85 0 0 1-.08-.362c0-.37.336-.679.743-.684.116-.001.283.08.583.283Z"
                      clip-rule="evenodd" />
                  </svg>
                </span>
                <span class="truncate-white-space">Crypto Payouts Admin</span>
              </router-link>
            </li>
            <!-- SIDEBAR ITEM : FIAT PAYOUTS -->
            <li
              class="vs-sidebar--item"
              v-if="activeMerchantGetter && activeMerchantGetter.is_fiat_payout">
              <router-link
                to="/fiat-payout-admin"
                exact
                @click.native="setActiveAccount('/fiat-payout-admin')">
                <span class="feather-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="25"
                    fill="none">
                    <path
                      fill="currentColor"
                      fill-rule="evenodd"
                      d="M1.202 1.049C.7 1.22.259 1.704.154 2.194.116 2.37.105 3.957.115 7.758l.015 5.32.129.262c.162.33.453.62.786.783l.258.127 2.949.013 2.948.013-.039.151a2.581 2.581 0 0 0-.038.48c.001.58.328 1.06.902 1.322.226.104.34.12.958.142.485.018.694.041.679.077-.012.028-.096.274-.186.545a6.063 6.063 0 0 0 .04 3.898c.19.525.187.507.078.507a.477.477 0 0 0-.399.234c-.068.115-.078.312-.078 1.57v1.44l.16.159.16.159h4.16c4.518 0 4.354.01 4.475-.257.079-.172.079-2.876 0-3.049-.083-.182-.27-.256-.646-.256-.182 0-.33-.01-.33-.02 0-.011.223-.445.496-.963 1-1.9 1.193-2.693 1.193-4.924v-1.214l2.077-.014 2.077-.013.265-.13c.338-.166.611-.439.777-.776l.13-.266V2.158l-.13-.266a1.698 1.698 0 0 0-.777-.776l-.265-.13-4.427-.013L14.084.96l-.16.16c-.217.217-.218.403-.001.62l.16.16h6.089l.051.27c.12.633.454 1.242.957 1.744.502.501 1.111.835 1.746.955l.27.052v5.415h-.114c-.201 0-.835.227-1.198.429-.462.257-1.004.798-1.262 1.26-.202.362-.429.996-.429 1.196v.115h-6.289v-2.32l.247-.136c.135-.075.45-.34.699-.59.4-.4.48-.51.695-.948.737-1.507.487-3.182-.65-4.366a3.89 3.89 0 0 0-1.775-1.071c-.298-.085-.483-.105-1-.104-.764.001-1.04.066-1.736.406-.44.215-.542.29-.962.712-.38.382-.511.553-.69.894-.34.653-.433 1.046-.432 1.805 0 .76.064 1.033.404 1.733.215.443.285.538.713.962.261.26.575.523.698.587l.223.116v2.32H4.07l-.051-.27c-.12-.634-.455-1.243-.957-1.744-.502-.502-1.112-.835-1.746-.956l-.27-.051V4.92l.27-.052c.634-.12 1.244-.454 1.746-.955.502-.502.836-1.11.957-1.744l.051-.27h3.02c3.276 0 3.214.004 3.333-.257a.45.45 0 0 0 0-.425c-.121-.266.06-.256-4.646-.255-4.034.002-4.349.008-4.574.086Zm10.69-.022c-.407.226-.237.872.229.872.238 0 .47-.229.47-.464a.474.474 0 0 0-.7-.408ZM3.09 2.028c-.215.93-.993 1.714-1.892 1.908l-.153.033V3.18c0-.882.035-1.001.34-1.187.137-.083.237-.093.944-.094h.791l-.03.13Zm19.783-.022c.284.19.323.334.323 1.198v.765l-.152-.032c-.88-.186-1.723-1.034-1.898-1.908l-.026-.13h.797c.75 0 .806.007.956.107ZM12.919 4.82c1.527.488 2.396 1.987 2.018 3.48-.149.586-.345.927-.792 1.376-.37.372-.397.39-.455.305-.428-.632-.909-.911-1.57-.911-.657 0-1.144.282-1.564.905-.053.078-.083.062-.366-.197a3.006 3.006 0 0 1-.828-1.258c-.103-.306-.123-.451-.124-.903-.003-.547.027-.7.22-1.149.28-.65.778-1.16 1.431-1.472.236-.113.38-.16.786-.258.175-.042 1.031.014 1.244.082ZM4.914 6.159c-.23.06-.628.294-.754.444a2.54 2.54 0 0 0-.241.377c-.106.203-.125.299-.126.638 0 .364.013.423.159.693.177.33.325.471.678.655.205.106.299.124.639.124s.434-.018.639-.124c.353-.184.5-.326.678-.655.146-.27.16-.329.158-.693 0-.339-.02-.435-.125-.638-.183-.352-.326-.5-.644-.67-.303-.161-.767-.228-1.061-.151Zm13.707 0a1.52 1.52 0 0 0-1.139 1.348c-.047.589.249 1.124.787 1.42.284.155.333.167.704.165.338-.001.435-.02.638-.126.354-.184.501-.326.679-.655.146-.27.16-.329.158-.693 0-.339-.02-.435-.125-.638-.183-.352-.326-.5-.644-.67-.302-.16-.768-.228-1.058-.152ZM5.663 7.24c.124.123.146.18.146.378 0 .2-.022.253-.154.385s-.186.154-.386.154-.254-.022-.386-.154c-.132-.131-.154-.186-.154-.383 0-.24.12-.43.329-.523.175-.077.45-.012.605.143Zm13.704 0c.124.123.145.18.145.378 0 .2-.02.253-.153.385-.132.132-.186.154-.386.154s-.254-.022-.386-.154c-.132-.131-.154-.186-.154-.383 0-.24.12-.43.329-.523.175-.077.45-.012.605.143Zm-6.932 2.818a.891.891 0 0 1 .43.395c.068.124.08.422.1 2.509l.024 2.368.154.313c.282.572.778.88 1.418.88.64 0 1.136-.308 1.418-.88.142-.287.156-.356.171-.841l.017-.529h1.689l-.022 1.442c-.02 1.232-.037 1.505-.121 1.886-.17.765-.38 1.283-1.042 2.547l-.641 1.226-2.647.012-2.647.01-.149-.339c-.583-1.323-.629-2.723-.133-4.045.067-.179.28-.6.472-.937l.35-.612v-2.378c0-2.56 0-2.567.249-2.836.204-.221.607-.306.91-.191ZM1.44 11.366c.81.279 1.467 1.006 1.644 1.818l.033.152H2.35c-.864 0-1.01-.04-1.2-.323-.1-.15-.106-.206-.106-.95 0-.63.013-.79.063-.79.035 0 .185.042.333.093Zm21.747.725c-.014.739-.024.83-.112.949-.19.258-.34.296-1.188.296h-.768l.026-.13c.153-.765.83-1.535 1.598-1.82.493-.183.46-.234.444.705Zm-12.85 2.664c0 .733.046.702-1.027.683-.764-.014-.89-.028-1.006-.105-.358-.243-.353-.708.01-.953.152-.102.199-.107 1.09-.107h.933v.482Zm4.88-.079c0 .639-.195.91-.657.91-.461 0-.657-.271-.657-.91v-.403h1.314v.403Zm1.971 8.503v.844h-7.133v-1.688h7.133v.844Z"
                      clip-rule="evenodd" />
                  </svg>
                </span>
                <span class="truncate-white-space">Fiat Payouts Admin</span>
              </router-link>
            </li>
          </ul>

          <h2>Tools</h2>
          <ul>
            <!-- SIDEBAR ITEM : INVOICING -->
            <li class="vs-sidebar--item">
              <router-link
                to="/payment-link"
                exact
                @click.native="setActiveAccount('/payment-link')">
                <span class="feather-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round">
                    <path
                      d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                    <polyline points="14 2 14 8 20 8" />
                    <line x1="9" y1="15" x2="15" y2="15" />
                  </svg>
                </span>
                <span class="truncate">Invoicing</span>
              </router-link>
            </li>

            <!-- SIDEBAR ITEM : CREATE CRYPTO PAYOUT -->
            <li
              v-if="activeMerchantGetter && activeMerchantGetter.can_withdraw">
              <div class="vs-sidebar--item">
                <router-link
                  to="/create-crypto-payout"
                  exact
                  @click.native="setActiveAccount('/create-crypto-payout')">
                  <span class="feather-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      fill="currentColor">
                      <path
                        fill-rule="evenodd"
                        d="M5.546.163C5.272.422.05 7.703.015 7.878c-.064.314.029.407 1.292 1.3.658.465 1.247.872 1.308.904.306.16.53.023.977-.595.2-.279.385-.5.41-.492.025.009.31.205.635.437.403.288.634.491.732.644.078.122.327.68.553 1.238.434 1.074.633 1.422 1.01 1.77.363.335 5.617 4.028 5.963 4.191.521.246 1.315.27 1.808.054l.221-.097-.021.533c-.034.836.208 1.535.731 2.112.255.281.878.718 1.104.774.128.032.13.038.13.536 0 .467.009.512.124.627a.384.384 0 0 0 .562 0c.111-.11.124-.166.124-.528v-.403h.355v.354c0 .359.051.524.198.635.133.102.353.075.488-.058.115-.114.125-.161.126-.615l.001-.492.342-.163c.403-.193.847-.56.892-.74.035-.137-.037-.314-.168-.413-.158-.12-.346-.07-.681.181-.718.538-1.517.637-2.295.285-.316-.144-.773-.553-.949-.851-.446-.753-.36-1.796.203-2.476.508-.615 1.437-.907 2.223-.7.341.09.56.205.857.45.179.147.296.205.413.205.308 0 .477-.258.356-.543-.08-.188-.576-.566-.958-.728l-.237-.1v-.495c0-.428-.014-.509-.104-.604-.163-.174-.425-.164-.593.021-.098.108-.114.181-.114.524v.4h-.355v-.4c0-.345-.015-.417-.118-.535-.163-.188-.41-.188-.574 0-.106.122-.118.186-.118.607v.472l-.331.161c-.183.089-.347.185-.365.215-.018.029-.06-.109-.094-.306-.087-.511-.272-.876-.605-1.193l-.284-.27.117-.076c.242-.157.921-.442 1.298-.544.578-.158 1.939-.157 2.518.002 1.389.379 2.588 1.35 3.21 2.599.381.764.524 1.383.522 2.254-.008 2.531-1.913 4.611-4.486 4.898-2.046.229-4.086-.89-4.998-2.74a6.2 6.2 0 0 1-.35-.874c-.108-.391-.23-1.38-.18-1.46.016-.025-.069-.095-.188-.154a5.39 5.39 0 0 1-.538-.334c-.176-.123-.335-.209-.354-.19-.073.072-.027 1.65.06 2.026.29 1.278.877 2.314 1.812 3.199.502.475.88.739 1.496 1.044a6.138 6.138 0 0 0 6.941-1.034c1.07-1.013 1.702-2.256 1.896-3.728.069-.52.032-1.38-.08-1.907a6.165 6.165 0 0 0-2.293-3.616c-.81-.607-2.292-1.146-3.204-1.252 0-.086-1.315-3.39-1.429-3.591a4.163 4.163 0 0 0-.135-.223c-.422-.644-1.045-1.218-1.675-1.532A44.292 44.292 0 0 0 14 5.984a358.39 358.39 0 0 0-1.768-.74L9.597 4.151l-.669-.47c-.368-.258-.682-.492-.7-.52-.016-.027.084-.212.223-.413.51-.734.507-.738-1.087-1.862C6.262.109 6.084 0 5.914 0c-.15 0-.234.037-.368.163Zm1.205 1.668c.367.262.62.474.6.505-.048.077-4.467 6.2-4.571 6.335l-.087.112-.6-.43a27.548 27.548 0 0 0-.672-.469c-.053-.03.517-.853 2.274-3.286 1.29-1.785 2.362-3.24 2.383-3.232.02.008.324.217.673.465Zm1.568 2.8.697.496 2.773 1.153c.845.352 1.643.69 2.211.937.458.199.767.338.833.378.143.085.335.246.521.428.233.228.457.49.568.677.105.178 1.25 3.039 1.25 3.124 0 .007-.143.037-.317.067-.174.03-.476.1-.671.153-.195.054-.368.082-.384.063a6.368 6.368 0 0 1-.222-.511c-.341-.844-.52-1.056-1.42-1.69-.8-.563-.877-.593-1.47-.594-.472 0-.533.012-.843.163-.398.194-.709.51-.896.907-.11.237-.134.358-.135.713 0 .381.017.463.161.753.09.179.26.417.38.53.12.112.933.708 1.806 1.324.969.683 1.627 1.18 1.687 1.276.15.237.113.7-.076.947-.314.407-.936.551-1.407.326-.13-.062-1.462-.982-2.96-2.045-2.05-1.454-2.765-1.987-2.888-2.155-.09-.123-.318-.608-.506-1.08-.632-1.58-.785-1.794-1.784-2.502-.313-.223-.57-.418-.569-.434 0-.015.64-.916 1.421-2 .942-1.307 1.442-1.96 1.482-1.935.033.02.374.26.758.532Zm-6.112 2.63c-.195.192-.186.476.02.68.137.135.18.15.363.126.263-.035.396-.166.431-.427.024-.181.01-.224-.127-.359-.206-.205-.492-.213-.687-.02Zm11.073 3.415c.94.635.946.643 1.28 1.427l.221.52-.286.19c-.158.103-.306.188-.33.188-.094 0-2.057-1.438-2.131-1.562a.85.85 0 0 1-.08-.362c0-.37.336-.679.743-.684.116-.001.283.08.583.283Z"
                        clip-rule="evenodd" />
                      <path
                        fill="currentColor"
                        d="M15 3v2.984h1L17 6h1v3h3V6h3V3h-3V0h-3v3h-3Z" />
                    </svg>
                  </span>
                  <span class="truncate-white-space">
                    Create Crypto Payout
                  </span>
                </router-link>
              </div>
            </li>

            <!-- /create-fiat-payout -->
            <li
              class="vs-sidebar--item"
              v-if="activeMerchantGetter && activeMerchantGetter.is_fiat_payout">
              <router-link
                to="/create-fiat-payout"
                exact
                @click.native="setActiveAccount('/create-fiat-payout')">
                <span class="feather-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><g fill="currentColor" clip-path="url(#a)"><path fill-rule="evenodd" d="M.772 7.063c-.355.121-.668.464-.742.811C.003 8-.005 9.123.002 11.815l.011 3.769.091.185c.115.234.321.44.557.555l.183.09 2.089.009 2.088.01-.027.106c-.02.112-.03.226-.027.34 0 .41.232.75.639.936.16.074.24.085.678.101.344.013.492.03.481.055-.008.02-.068.194-.132.386a4.295 4.295 0 0 0 .029 2.76c.134.373.132.36.055.36a.338.338 0 0 0-.283.166c-.048.081-.055.22-.055 1.112v1.02l.113.112.114.113h2.946c3.2 0 3.085.007 3.17-.182.056-.122.056-2.037 0-2.16-.058-.129-.191-.181-.457-.181-.13 0-.234-.007-.234-.014 0-.008.158-.316.351-.682.709-1.346.845-1.908.845-3.488v-.86l1.472-.01 1.47-.01.189-.091c.239-.118.432-.311.55-.55l.092-.188V7.849l-.092-.189a1.203 1.203 0 0 0-.55-.55l-.188-.092-3.136-.009L9.897 7l-.113.113c-.154.154-.154.286 0 .44l.113.113h4.313l.036.191c.085.448.322.88.678 1.235a2.4 2.4 0 0 0 1.237.677l.19.037v3.835h-.08c-.142 0-.591.161-.849.304a2.634 2.634 0 0 0-.893.893c-.143.256-.304.705-.304.847v.081H9.77v-1.643l.175-.096c.095-.053.319-.241.495-.418.283-.284.34-.361.492-.672.522-1.067.345-2.254-.46-3.092a2.756 2.756 0 0 0-1.257-.759c-.212-.06-.343-.074-.709-.074-.541.001-.736.047-1.23.288-.311.152-.383.205-.68.504-.27.27-.363.392-.49.633-.24.463-.306.742-.306 1.28 0 .537.046.73.286 1.227.153.313.202.38.506.681.184.184.407.37.494.416l.158.082v1.643h-4.44l-.036-.19a2.394 2.394 0 0 0-.678-1.236 2.405 2.405 0 0 0-1.237-.677l-.191-.037V9.805l.191-.037c.45-.085.881-.321 1.237-.676.356-.356.592-.787.678-1.236l.036-.19h2.14c2.32 0 2.276.002 2.36-.183a.319.319 0 0 0 0-.301c-.086-.188.043-.181-3.29-.18-2.858 0-3.081.005-3.24.06l-.002.001Zm7.573-.016c-.289.16-.168.618.162.618.168 0 .333-.162.333-.329a.336.336 0 0 0-.496-.289Zm-6.235.71c-.152.658-.704 1.214-1.34 1.351l-.109.023v-.559c0-.624.025-.709.241-.84.097-.06.168-.066.669-.067h.56l-.021.091Zm14.013-.016c.201.135.229.237.229.848v.542l-.108-.022c-.623-.132-1.22-.733-1.344-1.352l-.019-.092h.565c.531 0 .57.005.677.076Zm-7.05 1.993c1.08.346 1.696 1.408 1.429 2.465-.106.415-.245.657-.561.975-.262.263-.282.276-.323.216-.303-.448-.644-.645-1.112-.645-.465 0-.81.2-1.108.64-.037.056-.058.045-.259-.139a2.13 2.13 0 0 1-.586-.891c-.073-.217-.088-.32-.088-.64-.002-.387.019-.495.156-.813.198-.46.55-.822 1.013-1.043.167-.08.27-.114.557-.183.124-.03.73.01.881.058Zm-5.671.949c-.163.042-.445.208-.534.314a1.797 1.797 0 0 0-.171.267c-.075.144-.089.212-.09.452 0 .258.01.3.113.49.126.235.23.335.48.465.146.075.212.088.453.088.241 0 .308-.013.453-.088.25-.13.354-.231.48-.464.104-.191.114-.233.112-.49 0-.241-.014-.31-.088-.453-.13-.25-.231-.354-.457-.474-.214-.114-.543-.162-.751-.107Zm9.71 0a1.076 1.076 0 0 0-.808.954c-.033.418.177.797.558 1.006.201.11.236.119.498.117.24 0 .309-.014.452-.09.251-.13.355-.23.481-.463.104-.191.114-.233.112-.49 0-.241-.014-.31-.088-.453-.13-.25-.231-.354-.456-.474-.214-.114-.544-.161-.75-.107Zm-9.18.765c.088.087.104.128.104.268 0 .142-.016.18-.11.273-.093.093-.131.109-.273.109-.141 0-.18-.016-.273-.11-.094-.092-.11-.131-.11-.27 0-.17.086-.305.234-.371.124-.054.319-.008.428.101Zm9.708 0c.087.087.102.128.102.268 0 .142-.014.18-.108.273-.094.093-.132.109-.274.109-.141 0-.18-.016-.273-.11-.093-.092-.109-.131-.109-.27 0-.17.085-.305.233-.371.124-.054.319-.008.429.101Zm-4.91 1.996c.13.057.237.155.304.28.048.088.057.3.07 1.777l.018 1.678.109.221c.2.406.55.624 1.004.624.454 0 .805-.218 1.005-.624.1-.203.11-.252.12-.595l.013-.375h1.196l-.015 1.021c-.014.873-.027 1.066-.086 1.336-.12.542-.27.91-.738 1.805l-.454.868-1.875.008-1.875.008-.106-.24a3.73 3.73 0 0 1-.094-2.866c.048-.127.198-.425.334-.664l.248-.433v-1.684c0-1.814 0-1.819.177-2.01.144-.156.43-.216.644-.135Zm-7.789.927c.574.197 1.04.713 1.165 1.288l.023.107h-.543c-.612 0-.716-.028-.85-.229-.071-.106-.075-.145-.075-.672 0-.447.009-.56.044-.56.025 0 .131.03.236.066Zm15.405.513c-.01.524-.018.588-.08.673-.134.182-.24.21-.841.21h-.544l.018-.093c.108-.542.588-1.087 1.132-1.289.35-.13.326-.166.315.5Zm-9.103 1.887c0 .52.033.498-.727.484-.541-.01-.63-.02-.713-.074-.253-.172-.25-.502.007-.675.108-.072.141-.076.772-.076h.661v.341Zm3.457-.056c0 .453-.138.645-.465.645s-.466-.192-.466-.645v-.285h.931v.285Zm1.396 6.023v.598H7.043v-1.195h5.053v.597Z" clip-rule="evenodd"/><path d="M15 2.88v2.865h.96l.96.015h.96v2.88h2.88V5.76h2.88V2.88h-2.88V0h-2.88v2.88H15Z"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h24v24H0z"/></clipPath></defs></svg>                </span>
                <span class="truncate-white-space">Create Fiat Payout</span>
              </router-link>
            </li>

            <!-- SIDEBAR ITEM : STATEMENTS -->
            <li v-if="activeMerchantGetter">
              <div class="vs-sidebar--item">
                <router-link
                  to="/statements"
                  exact
                  @click.native="setActiveAccount('/statements')">
                  <span class="feather-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      width="24"
                      fill="currentColor">
                      <path fill="none" d="M0 0h24v24H0z" />
                      <path
                        d="M13.17 4 18 8.83V20H6V4h7.17M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zm1 9h-4v1h3c.55 0 1 .45 1 1v3c0 .55-.45 1-1 1h-1v1h-2v-1H9v-2h4v-1h-3c-.55 0-1-.45-1-1v-3c0-.55.45-1 1-1h1V8h2v1h2v2z" />
                    </svg>
                  </span>
                  <span class="truncate-white-space"> Statements </span>
                </router-link>
              </div>
            </li>

            <!-- SIDEBAR ITEM : WITHDRAWALS -->
            <li v-if="activeMerchantGetter">
              <div class="vs-sidebar--item">
                <router-link
                  to="/withdrawals"
                  exact
                  @click.native="setActiveAccount('/withdrawals')"
                >
                  <span class="feather-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="feather feather-dollar-sign vue-feather__content"
                    >
                      <line x1="12" y1="1" x2="12" y2="23"></line>
                      <path
                        d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"
                      ></path>
                    </svg>
                  </span>
                  <span class="truncate-white-space"> Withdrawals </span>
                </router-link>
              </div>
            </li>

            <!-- SIDEBAR ITEM : DEPOSITS -->
            <li v-if="activeMerchantGetter">
              <div class="vs-sidebar--item">
                <router-link
                  to="/deposits"
                  exact
                  @click.native="setActiveAccount('/deposits')"
                >
                  <span class="feather-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="feather feather-corner-down-right vue-feather__content"
                    >
                      <polyline points="15 10 20 15 15 20"></polyline>
                      <path d="M4 4v7a4 4 0 0 0 4 4h12"></path>
                    </svg>
                  </span>
                  <span class="truncate-white-space"> Deposits </span>
                </router-link>
              </div>
            </li>
          </ul>

          <h2>Developers</h2>
          <ul>
            <!-- SIDEBAR ITEM : LINK TO INTEGRATION DOCS -->
            <li class="vs-sidebar--item">
              <div style="display: flex; align-items: center; cursor: pointer">
                <a
                  href="https://doc.triple-a.io"
                  target="_blank"
                  rel="noopener">
                  <span class="feather-icon select-none relative">
                    <book-icon size="1.5x" class="custom-class"></book-icon>
                  </span>
                  <span class="truncate">Integration Docs</span>
                </a>
              </div>
            </li>

            <!-- SIDEBAR ITEM : LINK TO RESET SECRET -->
            <li class="vs-sidebar--item">
              <div style="display: flex; align-items: center; cursor: pointer">
                <router-link
                  to="/api-credentials"
                  exact
                  @click.native="setActiveAccount('/api-credentials')">
                  <span class="feather-icon select-none relative">
                    <lock-icon size="1.5x" class="custom-class"></lock-icon>
                  </span>
                  <span class="truncate">API Credentials</span>
                </router-link>
              </div>
            </li>
          </ul>

          <h2>Support</h2>
          <ul>
            <!-- SIDEBAR ITEM : LINK TO FAQ -->
            <li class="vs-sidebar--item">
              <div style="display: flex; align-items: center; cursor: pointer">
                <a
                  href="https://support.triple-a.io/knowledge"
                  target="_blank"
                  rel="noopener">
                  <span class="feather-icon select-none relative">
                    <help-circle-icon
                      size="1.5x"
                      class="custom-class"></help-circle-icon>
                  </span>
                  <span class="truncate">FAQ</span>
                </a>
              </div>
            </li>

            <!-- SIDEBAR ITEM : LINK TO CONTACT US  -->
            <li class="vs-sidebar--item">
              <div style="display: flex; align-items: center; cursor: pointer">
                <a
                  href="mailto:support@triple-a.io?subject=Contact via TripleA Dashboard"
                  target="_blank">
                  <span class="feather-icon select-none relative">
                    <mail-icon size="1.5x" class="custom-class"></mail-icon>
                  </span>
                  <span class="truncate">Contact Us</span>
                </a>
              </div>
            </li>
          </ul>
        </VuePerfectScrollbar>
      </div>
    </div>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import {
  DollarSignIcon,
  RotateCcwIcon,
  BookIcon,
  LockIcon,
  MailIcon,
  MonitorIcon,
  RefreshCwIcon,
  ArrowUpRightIcon,
  HomeIcon,
  CornerUpLeftIcon,
  ChevronRightIcon,
  CopyIcon,
  HelpCircleIcon,
} from 'vue-feather-icons';
import { mapActions, mapGetters } from 'vuex';
import OtpPrompt from '../../../components/OtpPrompt.vue';

export default {
  name: 'custom-sidebar',
  //   props: {
  //     sidebarItems: {
  //       type: Array,
  //       required: true
  //     }
  //   },
  components: {
    VuePerfectScrollbar,
    DollarSignIcon,
    RotateCcwIcon,
    BookIcon,
    LockIcon,
    MailIcon,
    MonitorIcon,
    RefreshCwIcon,
    ArrowUpRightIcon,
    HomeIcon,
    CornerUpLeftIcon,
    OtpPrompt,
    ChevronRightIcon,
    CopyIcon,
    HelpCircleIcon,
  },
  data() {
    return {
      //   sidebarGroup: this.submenu(),
      isGroupContainerOpen: false,
      showShadowBottom: false,
      maxHeight: '0px',
      debugConsole: false,
      isWithdrawalContainerOpen: false,
      withdrawalCurrencies: [
        'USD',
        'EUR',
        'AUD',
        'CAD',
        'CHF',
        'GBP',
        'HKD',
        'IDR',
        'JPY',
        'KRW',
        'MYR',
        'NOK',
        'NZD',
        'PHP',
        'SEK',
        'SGD',
        'THB',
        'TWD',
        'VND',
      ],
      backgroundLoading: 'primary',
      colorLoading: '#fff',

      intervalId: '',
      lastUpdated: new Date().toLocaleTimeString(),
      intervalIdForBalance: '',

      searchMerchantQuery: '',

      isMerchantContainerOpen: false,

      searchQuery: '',

      openedMerchantAccount: '',
      openedMerchantMainAccounts: '',
      openedMerchantTestAccounts: '',

      merchantKeyCopied: false,
      apiIdCopied: false,
      showOtpPrompt: false,
      isAllowedToRequestReset: false,

      isMerchantKeyDisplayed: false,
      isMerchantApiIdsDisplayed: false,

      valueOfCopiedApiId: '',
    };
  },

  created() {
    if (this.debugConsole) console.debug('SidebarGroup', this.sidebarGroup);

    let activeAccount = this.activeAccountGetter.apiId
      ? this.activeAccountGetter
      : null;
    if (this.debugConsole) console.debug('Active Account', activeAccount);

    if (this.debugConsole)
      console.debug('Accounts', this.$store.state.accounts);

    if (this.debugConsole)
      console.debug(
        'Main Account getters',
        this.$store.getters.mainAccountsGetter
      );
    if (this.debugConsole)
      console.debug(
        'Test Account getters',
        this.$store.getters.testAccountsGetter
      );
    if (this.debugConsole) console.debug('Window width', this.windowWidth);
  },
  mounted() {
    //check if only one account
    if (this.accountsGetter && this.accountsGetter.length === 1) {
      this.isGroupContainerOpen = true;
    }
    this.updateResetRequestRights();
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  },
  computed: {
    ...mapGetters([
      'activeAccountGetter',
      'mainAccountsGetter',
      'testAccountsGetter',
      'localCurrencyGetter',
      'exchangeRateGetter',
      'accountsGetter',
      'activeMerchantGetter',
      'activeMerchantBalances',
      'merchantExchangeRateGetter',
      'merchantsGetter',
      'currentActiveEntityAdminGetter',
    ]),
    merchantApiIds() {
      let apiIds = this.activeMerchantGetter && [
        ...this.activeMerchantGetter.accounts,
      ];
      let sortedApiIds =
        apiIds.length > 0
          ? apiIds.sort((a, b) =>
            a.crypto_currency > b.crypto_currency ? 1 : -1
          )
          : [];
      return sortedApiIds;
    },
  },

  watch: {
    activeMerchantGetter(newValue, oldValue) {
      if (this.debugConsole)
        console.debug(
          'watch: activeMerchantGetter: update detected',
          newValue,
          oldValue
        );
      this.updateResetRequestRights();
    },
  },
  methods: {
    ...mapActions([
      'fetchExchangeRate',
      'fetchMerchantExchangeRate',
      'fetchMerchantTransactions',
      'fetchMerchantTransactionsSummary',
    ]),

    displayMerchantKey() {
      this.isMerchantKeyDisplayed = !this.isMerchantKeyDisplayed;
    },

    displayMerchantApiIds() {
      this.isMerchantApiIdsDisplayed = !this.isMerchantApiIdsDisplayed;
    },

    copyMerchantKey(value) {
      this.copyToClipboard(value);
      this.merchantKeyCopied = true;
      setTimeout(() => {
        this.merchantKeyCopied = false;
      }, 1000);
    },

    copyApiId(value) {
      this.copyToClipboard(value);
      this.valueOfCopiedApiId = value;
      this.apiIdCopied = true;
      setTimeout(() => {
        this.apiIdCopied = false;
      }, 1000);
    },

    toggleMerchantAccounts(value) {
      this.openedMerchantAccount = value;

      if (this.debugConsole) console.log('opened Merchant Account', value);

      this.openedMerchantMainAccounts = this.openedMerchantAccount.accounts.filter(
        (item) => item.api_id.indexOf('_t') < 0
      );
      this.openedMerchantTestAccounts = this.openedMerchantAccount.accounts.filter(
        (item) => item.api_id.indexOf('_t') >= 0
      );
      if (this.debugConsole)
        console.log(
          'opened Merchant Main Accounts',
          this.openedMerchantMainAccounts
        );
      if (this.debugConsole)
        console.log(
          'opened Merchant Test Accounts',
          this.openedMerchantTestAccounts
        );
    },

    toggleGroupContainer() {
      console.debug('toggle Debug', !this.isGroupContainerOpen);
      this.isGroupContainerOpen = !this.isGroupContainerOpen;
    },

    psSectionScroll() {
      if (this.$refs.mainSidebarPs.$el.scrollTop > 0) {
        if (this.debugConsole)
          console.log('scrollbar', this.$refs.mainSidebarPs.$el.scrollTop);
        this.showShadowBottom = true;
      } else {
        this.showShadowBottom = false;
      }
    },

    setActiveAccount(to, apiId) {
      if (apiId) {
        this.isGroupContainerOpen = !this.isGroupContainerOpen;
      }

      if (this.debugConsole)
        console.log('Group Item inside setActiveAcc function', apiId);
      if (this.debugConsole) console.debug('setActiveAccount(): ', apiId);
      if (apiId) {
        if (this.debugConsole)
          console.debug(
            'setActiveAccount(): RouterLink on item clicked. Setting active account to ' +
            apiId
          );
        this.$store.commit('SET_ACTIVE_ACCOUNT', apiId);

        if (this.debugConsole)
          console.log(
            'this.$router.currentRoute.fullPath',
            this.$router.currentRoute.fullPath
          );

        if (to && to !== this.$router.currentRoute.fullPath) {
          if (this.debugConsole)
            console.debug(
              'setActiveAccount(): router to: ',
              to,
              this.$router.currentRoute.fullPath
            );
          this.$router.push(to);
        }
      }
    },

    toggleWithdrawalContainer() {
      this.isWithdrawalContainerOpen = !this.isWithdrawalContainerOpen;
    },

    setActiveMerchantAccount(to, merchant) {
      this.isGroupContainerOpen = !this.isGroupContainerOpen;

      if (this.debugConsole) console.log('Merchant selected', merchant);

      //SELECT THE LOCAL CURRENCY ACCOUNT FROM THE LOCAL CURRENCY MERCHANT, ONLY AS AN IDENTIFIER (NOT TO BREAK THINGS)
      let merchantBTCLocalCurrencyAccount = merchant.accounts.find(
        (item) =>
          item.crypto_currency === 'BTC' &&
          item.settlement_type === 'localcurrency'
      );
      if (this.debugConsole)
        console.log('MERCHANT BTC ACCOUNT', merchantBTCLocalCurrencyAccount);

      this.$store.commit(
        'SET_ACTIVE_ACCOUNT',
        merchantBTCLocalCurrencyAccount.api_id
      );

      let payload = {};
      payload.merchantKey = merchant.merchant_key;

      //testing merchant payments API
      this.fetchMerchantTransactions(payload).then((res) => {
        if (this.debugConsole) console.log('merchant txn result', res.data);

        let testTxn = res.data.data.filter((txn) => txn.api_id.includes('_t'));
        if (this.debugConsole) console.log('Test transactions', testTxn);

        let realTxn = res.data.data.filter((txn) => !txn.api_id.includes('_t'));
        if (this.debugConsole) console.log('Real transactions', realTxn);

        let custodyTxn = realTxn.filter(
          (txn) => txn.account_type === 'custody'
        );
        if (this.debugConsole) console.log('Custody Txn', custodyTxn);

        let localCurTxn = realTxn.filter(
          (txn) => txn.account_type === 'triplea'
        );
        if (this.debugConsole) console.log('Local Currency Txn', localCurTxn);

        if (to && to !== this.$router.currentRoute.fullPath) {
          if (this.debugConsole)
            console.debug(
              'setActiveAccount(): router to: ',
              to,
              this.$router.currentRoute.fullPath
            );
          this.$router.push(to);
        }
      });

      this.fetchMerchantTransactionsSummary(payload).then((res) => {
        if (this.debugConsole) console.log('Merchant Txn Summary', res.data);
      });
    },
    toggleOtpPrompt() {
      this.showOtpPrompt = true;
    },
    goToResetPage() {
      this.$router.push('reset-secret');
    },
    updateResetRequestRights() {
      const currentActiveMerchantId =
        this.activeMerchantGetter && this.activeMerchantGetter.id;
      this.isAllowedToRequestReset = this.isAllowed(
        this.currentActiveEntityAdminGetter,
        currentActiveMerchantId,
        'reset_client_secret',
        'W'
      );
    },
  },
};
</script>

<style lang="scss" scoped>
section.ps-container {
  padding: 0 15px;

  h2 {
    padding: 10px;
    margin-left: 5px;
    font-size: 15px;
    font-weight: 500;
    color: darkgrey;
  }

  &>span.navigation-smalltext {
    margin-left: 15px;
  }

  ul {
    margin-bottom: 12px;

    li {
      display: block;

      &.vs-sidebar-group {
        .group-header {
          padding-right: 0;

          span.feather-grp-header-arrow {
            position: absolute;
            margin-right: 0;
            right: 5px;
            top: 6px;
            padding: 0;
            -webkit-transition: all 0.1s ease-out;
            transition: all 0.1s ease-out;
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);

            &.rotate90 {
              transform: rotate(90deg);
              -webkit-transform: rotate(90deg);
            }
          }
        }
      }

      .vs-sidebar-group-items {
        .vs-sidebar--item {
          background: rgba(255, 255, 255, 0.7);
          border-radius: 4px;
          margin-bottom: 4px;
        }
      }
    }
  }
}

.copied-msg {
  position: absolute;
  text-align: center;
  background-color: #2774b1;
  border-radius: 5px;
  color: #ffffff;
  top: 20px;
  right: 0px;
  z-index: 2;
}

.active-background-color {
  background-color: #d3d3d391;
}

.currency-identifier {
  font-size: 0.7em;
  font-weight: 600;
  white-space: nowrap;
  word-break: break-word;
}

.includeIconOnly {
  width: 20px !important;
  height: 20px !important;
}

.merchant-group-arrow {
  position: absolute !important;
  right: -18px !important;
  top: 2px;
  //padding: 10px;
  -webkit-transition: all 0.1s ease-out;
  transition: all 0.1s ease-out;
  -webkit-transform: rotate(0deg);
  transform: rotate(0deg);
  display: inline-block;
}

.logoSideBar {
  display: inline-block;
  width: 170px;
}

.dropdown-normal-container {
  display: inline-block;
  background-color: #262626;
  padding-left: 8px;
}

.sidebar-item {
  padding: 10px;
  margin: 5px;
  white-space: nowrap;
  word-break: break-all;
  background-color: rgba(255, 255, 255, 0.7);
}

.sidebar-item-withdrawal {
  margin-left: 35px;
  color: #626262 !important;
  font-size: 13px !important;
}

.sidebar-item:hover {
  cursor: pointer;
}

.logo a {
  margin: auto auto 0px !important;
}

/*.sidebar-item-withdrawal:hover {*/
/* cursor:pointer;*/
/*}*/

.account-type-icon-plus {
  width: 18px;
  filter: invert(0.4) contrast(10.5);
}

.close-button {
  display: none;
}

@media only screen and (max-width: 1200px) {
  .close-button {
    display: block;
  }

  .sidebar-background {
    background: rgba(0, 0, 0, 0.2);
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 51000;
  }
}

.main-menu-sidebar-overlay {
  z-index: 51000;
}

.scroll-area--main-sidebar {
  position: relative;
  margin: auto;
  width: 100%;
  height: calc(100vh - 120px) !important;
}

.active-balance {
  background-color: #ffffff !important;
  color: #0a5692;
  font-size: 130% !important;
  border: 0.5px solid #0a5692;
}

#merchant-id:hover {
  position: relative !important;
  display: block;
  overflow-y: scroll !important;
  -webkit-overflow-scrolling: touch;
  box-sizing: border-box;
}

*::-webkit-scrollbar {
  width: 12px;
}

*::-webkit-scrollbar-track {
  background: orange;
}

*::-webkit-scrollbar-thumb {
  background-color: blue;
  border-radius: 20px;
  border: 3px solid orange;
}

.active-header {
  padding: 10px 10px 0 10px;
  margin: 0 0 12px 5px;
  font-size: 1em;
  font-weight: 400;
  color: #565656;
  cursor: pointer;
}

.rotate90 {
  transform: rotate(90deg);
  -webkit-transform: rotate(90deg);
}

.list-items {
  padding: 0;
  font-weight: 600;
  word-break: break-all;
  font-size: 0.8em;
  margin: 2px;
}
</style>
